import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { getAllBatches, deleteBatch } from "../server/rolesAllApi";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios"; // Make sure axios is imported
import Breadcrumb from "../Breadcrumb";
// for deletion
import { Modal } from "react-bootstrap";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const SubscriptionPlan = () => {
  const [subscription, setSubscription] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [token, setToken] = useState("");
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // for deletion
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);

  useEffect(() => {
    if (token) {
      fetchSubscription();
    }
  }, [token, currentPage, itemsPerPage, searchTerm]); // Added selectedBatchId to trigger re-fetch

  const fetchSubscription = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      // Construct the API URL with query parameters including selectedBatchId
      const url = `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-subscription?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // setSubscription(response.data.data.data); // Update to your API structure
      // setTotalItems(response.data.data.pagination.totalItems); // Assuming your API returns this
      // console.log("Response received:", response);
      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setSubscription(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems); // Set totalItems for pagination
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch subscription plans:", error);
      setError("Failed to fetch subscription plans.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditPlan = (plans) => {
    navigate("/edit-subscription", { state: { plans } });
  };

  // for Deletion
  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleConfirmDelete = async () => {
    try {
      // Your delete logic here
      await handleDeletePlan(itemToDelete);
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const handleDeletePlan = async (plans) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/delete-subscription/${plans._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setSnackbarMessage("Deleted successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        handleCloseDeleteModal();

        fetchSubscription();
      }
    } catch (err) {
      console.error(err);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleToggleStatus = async (item) => {
    try {
      const updatedStatus = !item.status; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/subscription-status-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        fetchSubscription((prevBatches) =>
          prevBatches.map((b) =>
            b._id === item._id ? { ...b, status: updatedStatus } : b
          )
        );
        setSnackbarMessage("Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle subscription status:", error);
      setSnackbarMessage("Failed to update status. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <div className="d-flex justify-content-between">
        <h5>Subscriptions 123546523 </h5>
        <Breadcrumb title="Subscription" />
      </div>
      <div className="card h-100 p-0 radius-12">
        
{loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>
          <Link
            to="/add-subscription"
            className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
          >
            <Icon
              icon="ic:baseline-plus"
              className="icon text-xl line-height-1"
            />
            Add New
          </Link>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.L
                    </div>
                  </th>
                  <th scope="col">Amount Paid </th>
                  <th scope="col">Title</th>
                  <th scope="col">Term</th>
                  <th scope="col">Subscription Features</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Status</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {subscription.length > 0 ? (
                  subscription.map((subscrip, index) => (
                    <tr key={subscrip._id}>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          <div className="form-check style-check d-flex align-items-center">
                            {/* <input
                            className="form-check-input radius-4 border border-neutral-400"
                            type="checkbox"
                            name="checkbox" /> */}
                          </div>
                          {subscrip.serial}
                        </div>
                      </td>
                      <td>{subscrip.amount_paid}</td>
                      <td>{subscrip.title}</td>
                      <td>{subscrip.term}</td>
                      <td
                        style={{
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {subscrip.subscription_features.split(",").join(", ")}
                      </td>
                      <td>{new Date(
                          subscrip.createdAt
                        ).toLocaleDateString()}{" "}
                        {new Date(
                          subscrip.createdAt
                        ).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}</td>
                      <td className="text-center">
                        <button
                          onClick={() => handleToggleStatus(subscrip)}
                          className={`bg-${
                            subscrip.status ? "success" : "danger"
                          }-focus text-${
                            subscrip.status ? "success" : "danger"
                          }-600 border border-${
                            subscrip.status ? "success" : "danger"
                          }-main px-24 py-4 radius-4 fw-medium text-sm`}
                          style={{ cursor: "pointer" }}
                        >
                          {subscrip.status ? "Active" : "Inactive"}
                        </button>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleEditPlan(subscrip)}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </button>
                          {/* for deletion */}
                          <button
                            type="button"
                            className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleDeleteClick(subscrip)}
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="menu-icon"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No subcriptions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
            <span>
              Showing{" "}
              {subscription.length === 0
                ? "0"
                : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
              to {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
              {totalItems} entries
            </span>

            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              {/* Previous Button */}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  to="#"
                  onClick={() => handlePageChange(currentPage - 1)}
                  style={{
                    pointerEvents: currentPage === 1 ? "none" : "auto",
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                >
                  <Icon icon="ep:d-arrow-left" />
                </Link>
              </li>

              {/* Current Page Number */}
              <li className="page-item">
                <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                  {currentPage}
                </span>
              </li>

              {/* Next Button */}
              <li className="page-item">
                <Link
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  to="#"
                  onClick={() => handlePageChange(currentPage + 1)}
                  style={{
                    pointerEvents: currentPage === totalPages ? "none" : "auto",
                    opacity: currentPage === totalPages ? 0.5 : 1,
                  }}
                >
                  <Icon icon="ep:d-arrow-right" />
                </Link>
              </li>
            </ul>
          </div>
          {/* for deletion */}
          <Modal
            show={showDeleteModal}
            onHide={handleCloseDeleteModal}
            centered
            backdrop="static"
            size="sm"
          >
            <div className="modal-content radius-16 bg-base">
              <div className="modal-body p-24 text-center">
                <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                  <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                </span>
                <h6 className="text-lg fw-semibold text-primary-light mb-0">
                  Are you sure you want to delete this subscription plan?
                </h6>
                <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                  <button
                    type="button"
                    onClick={handleCloseDeleteModal}
                    className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleConfirmDelete}
                    className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={snackbarSeverity}
              sx={{ width: "100%" }}
            >
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default SubscriptionPlan;
